import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/header-top.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-07c48166"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "top-header"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "top-header-cont flex flex-items-center flex-justify-between"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    "class": "w-257px h-auto"
  })], -1);
});
var _hoisted_3 = [_hoisted_2];
export default {
  __name: 'header',
  setup: function setup(__props) {
    // const props = defineProps({
    //   active: {
    //     type: Number,
    //     default: 0,
    //   },
    // });
    // const { active } = toRefs(props);

    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
    };
  }
};